module.exports = __webpack_public_path__ + "media/components/country-flag/static/cp-d7f8fa803fe04f80a894523ac816c483.svg";